<template>
  <generic-modal :title="$t('template')" ref="generic_modal">
    <form>
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("name") }}</label>
            <div class="control">
              <input
                type="text"
                class="input"
                v-model="meta.name"
                :placeholder="$t('name')"
              />
            </div>
          </div>
        </div>
      </div>
      <accounts ref="accounts" />
    </form>
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  get,
  post,
  error_alert,
  generate_error_message_text,
  get_currency_settings,
  format_currency,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
import Accounts from "./Accounts.vue";

export default {
  name: "TemplateModal",
  components: { GenericModal, Accounts },
  props: {},
  data() {
    return {
      meta: {},
      error: "",
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      return !v.meta.name;
    },
  },
  methods: {
    close_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.close_modal();
    },
    show_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.show_modal();
    },
    edit_modal(uuid) {
      let v = this;
      v.set_initial_state();
      get("/accounting/account-template", { uuid: uuid })
        .then((template) => {
          v.meta = template;
          v.$refs.accounts.set_tree(template.settings.tree);
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
      v.$refs.generic_modal.show_modal();
    },
    save() {
      let v = this;
      let data = { ...v.meta };

      if (data.uuid) {
        post("/accounting/account-template", data)
          .then(() => {
            v.$emit("success");
            v.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      } else {
        put("/accounting/account-template", data)
          .then(() => {
            v.$emit("success");
            v.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      }
    },
    set_initial_state() {
      let v = this;
      v.meta = {
        name: "",
        settings: {},
      };
      v.error = "";
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style></style>
